import ApiService from '@/services/api.service'

const FieldsSetupService = {
    getAll( parameter) { 
      const requestData = {
        method: 'get',
        url: "/FieldsSetups/",
        headers: {
        },
        params: { 
          ProviderCode: parameter.ProviderCode,
          SearchCriteria: parameter.SearchCriteria,
          ScreenRecId: parameter.ScreenRecId,
        }
      }     
      return ApiService.customRequest(requestData);         
    },
    saveBulk(data){
      return ApiService.post(`/FieldsSetups/bulk`,data)
    },

    /*get(id) {
      return ApiService.get(`/FieldsSetups/${id}`);
    },

    add(data){
      return ApiService.post(`/FieldsSetups`,data)
    },

    delete(id){
      return ApiService.delete(`/FieldsSetups/${id}`)
    },

    update(id,data){
      return ApiService.put(`/FieldsSetups/${id}`,data)
    }*/
}
  
  export default FieldsSetupService;